const ru = {
  inDevTxt: 'В разработке',
  doneTxt: 'Готово',
};

export default ru;
